
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ie/car/30-day",
      function () {
        return require("private-next-pages/ie/car/30-day.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ie/car/30-day"])
      });
    }
  